import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import { COMMON } from "constants/brm";
import * as KeyFactory from "./exchange-query-key-factory";

/**
 * Retrieve consumer for an exchange
 *
 * @param {string} exchangeId - uuid of exchange
 * @returns list of all persons within the given exchange
 */
export const getExchangeConsumer = async ({ exchangeId }: { exchangeId: string | null }) => {
  if (exchangeId === null) {
    return Promise.reject(new Error("Invalid exchangeId id"));
  }

  const data = await Brm.exchangeApi.getExchangeConsumer(exchangeId);
  if (!Array.isArray(data)) {
    return data?.id === COMMON.nullUuid ? [] : [data];
  }
  return data || [];
};

interface IExchangeConsumerProps {
  exchangeId: string | null;
  options?: QueryOption<typeof getExchangeConsumer>;
}

/**
 * Custom-hook to retrieve consumer for an exchange.
 *
 * @param {string} exchangeId - uuid of exchange
 * @param {object} options - react-query configuration object
 * @returns react-query for findNode
 */
export const useExchangeConsumer = ({ exchangeId, options = {} }: IExchangeConsumerProps) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.exchangeKeys.consumer(exchangeId),
    queryFn: () => getExchangeConsumer({ exchangeId }),
  });
};
